import React, { useRef, useState } from 'react';
import './ContactForm.css';
import axios from 'axios';
import { INSTRUCTOR_URL } from '../../Services/Services';
import { toast } from 'react-toastify';
import { ClipLoader } from 'react-spinners';

const ContactForm = () => {
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const fileInputRef = useRef(null);

  const userId = localStorage.getItem('userId');


  const validatePhoneNumber = (phone) => {
    const phoneRegex = /^[0-9]{10}$/;
    return phoneRegex.test(phone);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    toast.dismiss();
    if (!userId) {
      toast.error('Please log in to create the ticket');
      return;
    }

    if (!validatePhoneNumber(phone)) {
      toast.error('Please enter a valid 10-digit phone number.');
      return;
    }

    if (!validateEmail(email)) {
      toast.error('Please enter a valid email address.');
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append('phoneNumber', phone);
    formData.append('email', email);
    formData.append('description', message);

    if (attachments && attachments.length > 0) {
      Array.from(attachments).forEach((file) => {
        formData.append('attachments', file);
      });
    }

    try {
      const response = await axios.post(`${INSTRUCTOR_URL}/contact-support`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      toast.dismiss();
      if (response.status === 200) {
        toast.success('Support request sent successfully!');
        setPhone('');
        setEmail('');
        setMessage('');
        setAttachments([]);
        fileInputRef.current.value = null;
      } else {
        toast.error('Failed to send the support request.');
      }
    } catch (error) {
      toast.dismiss();
      toast.error('An error occurred while sending your request.');
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    setAttachments(e.target.files);
  };

  return (
    <div className="contact-section">
      <div className="contact-form">
        <h2>Get In Touch</h2>
        <p>We are here to assist you. Feel free to reach out!</p>
        <form onSubmit={handleSubmit}>
          <input
            type="tel"
            placeholder="Enter your phone number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <textarea
            placeholder="Leave your message..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          />
          <input
            type="file"
            multiple
            onChange={handleFileChange}
            ref={fileInputRef}
            style={{ marginBottom: '20px', color: 'white' }}
          />
          <button type="submit">
            {loading ? <ClipLoader color="white" loading={loading} size={24} /> : 'Submit'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
